<panel width="400">
	<menu always-visible>
		<menuitem (click)="createQuery()">{{ 'query.create' | translate }}</menuitem>
	</menu>
	<h1>{{'query.list-queries' | translate}}</h1>
	@if (!queries) {
		<skeletons [defaultSkeletons]="3" />
	}
	@else {
		<list-view [emptyLabel]="'query.query-list.query-list-empty-label'">
			<header defaultSort="ascending">{{ 'query.column.query-name' | translate }}</header>
			<header></header>
			<row *listData="let query from queries" [highlighted]="selectedQuery == query" (action)="displayQuery(query)">
				<column>{{ query.name }}</column>
				<column align-right>@if (canDeleteQuery(query)) {<icon (click)="$event.stopPropagation(); deleteQuery(query)" type="trash-alt" />}</column>
			</row>
		</list-view>
	}
</panel>
